// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import createApp from "~/app";
createApp();
